import React, { useState, useEffect } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import favicon from './favicon.ico'
import './App.css';
import moment from 'moment'


function Home(props) {   
    const stats = props.stats
    const [capacityType, setCapacityType] = useState(0)

    const toggleCapacity = () => {
        capacityType == 0 ? setCapacityType(1) : setCapacityType(0)
    }
    useEffect(() => {
        props.refreshStats()
    }, [])
    return (
        <>
                <h4 className="text-center text-2xl md:text-3xl font-bold font-sans text-purple-400 mb-7" onClick={() => {
                    toggleCapacity()
                }}>
                    <div className="flex justify-center">
                        <img className="mb-6 w-10 h-10" src={favicon}/>
                    </div>
                    Capacity at CCK AF Gyms
                </h4>

                {/* <p className="mt-4 text-xs md:text-sm text-gray-300 text-center mb-2"
                onClick={() => {
                    toggleCapacity()
                }}>
                    Tap to Show {capacityType == 0 ? "Percentage" : "Number"} 
                </p> */}
                <div className="grid grid-cols-12 gap-2">
                                    <div className="col-span-12">
                                        <h3 className="mt-4 text-md md:text-lg text-purple-300 text-center">
                                            AF Stats has been sunset as of 14 April 2022 as crowd monitoring is no longer needed due to the government's easing of COVID measures.
                                            </h3>
                                    </div>
                                    {/* <div className="col-span-6">
                                        <h1 className="text-center text-5xl text-purple-700 mb-4"
                                        onClick={() => {
                                            toggleCapacity()
                                        }}>
                                                {
                                                    stats == "loading" ?
                                                    <Skeleton 
                                                    baseColor="#dec2ff"
                                                    highlightColor="#f7f0ff"
                                                    width={"1.2em"}/>
                                                    :
                                                    Number.isNaN(stats.cckc) ?
                                                    "?" : capacityType == 0 ?
                                                    stats.cckc
                                                    :
                                                    (Math.round((stats.cckc/46)*100)) + "%"
                                                }
                                        </h1>
                                        <h4 className="text-center sm:text-lg font-bold text-md text-purple-500">
                                            CCKC
                                        </h4>
                                        <h4 className="text-center text-sm text-purple-500">
                                            Max: 46
                                        </h4>
                                    </div> */}
                </div>
                <p className="mt-4 text-sm md:text-md text-purple-300 text-center">
                    {
                        stats == "loading" ?
                        <Skeleton 
                        baseColor="#dec2ff"
                        highlightColor="#f7f0ff"
                        width={"10.5em"}/>
                        :
                        "Last updated " + moment.unix(stats.timestamp).fromNow()
                    }
                </p>
                {/* <p className="mt-4 text-lg md:text-xl text-purple-300 text-left">From this website, you can view song statistics from Singapore's Kiss92 Radio Station.</p> */}
                <p className="text-center text-sm">
                <Link to="/chart">
                    <button className="mt-6 mb-2 self-start justify-self-start bg-purple-500 hover:bg-purple-700 text-white py-2 px-5 rounded-full">View Chart</button>
                </Link>
                </p>

        </>
    )
}

export default Home
